import type {
  TelegramCategoryDynamicParameterResponseDto,
  TelegramCategoryParameterResponseDto,
  TelegramCategoryResponseDto,
  TelegramCityResponseDto,
  TelegramCountryResponseDto,
  TelegramRegionResponseDto,
} from '@/generated';

export type ExtentedCategoryParameters = (
  | TelegramCategoryParameterResponseDto
  | TelegramCategoryDynamicParameterResponseDto
) & { parentId?: string };

export type ExtendedCategoryParamsDict = {
  [id: string]: ExtentedCategoryParameters;
};

export type GeoItem =
  | { countryId: string; name: string }
  | { regionId: string; name: string }
  | { cityId: string; name: string };

export type DictCategory = Omit<TelegramCategoryResponseDto, 'children'>;

export type GeoPieceInput = TelegramCountryResponseDto | TelegramRegionResponseDto | TelegramCityResponseDto;

export enum GeoType {
  country = 1,
  region = 2,
  city = 3,
}

export type GeoPieceOutput = { id: string; t: GeoType; pn?: string };

export type GeoDict = {
  [key: string]: GeoPieceOutput;
};

export type CategoryNameDict = {
  [key: string]: DictCategory[];
};

export type CategoryIdDict = {
  [id: string]: DictCategory;
};

export type Dicts = {
  categoryIdDict: CategoryIdDict;
  categoryNameDict: CategoryNameDict;
  geoDict: GeoDict;
};
